import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { THEMES, themeProgressPct } from '../data/learning';
import { ThemeGlyph, Track } from '../components/ui/learnbits';
import { ThemeIllustration } from '../components/ui/illustrations';
import { Reveal } from '../components/ui/motion';

export const Themes: React.FC = () => {
  const statusOf = (pct: number) => (pct >= 100 ? '✓ Afgerond' : pct > 0 ? 'Bezig' : 'Nieuw');

  return (
    <div className="shell py-12 sm:py-16">
      <h1 className="font-display font-bold text-ink mb-3 anim-rise" style={{ fontSize: 'clamp(30px,4.5vw,44px)', letterSpacing: '-0.02em' }}>Vijf thema’s, één leerlijn</h1>
      <p className="text-sub mb-10 max-w-readable anim-rise" style={{ fontSize: 18, animationDelay: '70ms' }}>Kies waar je wilt beginnen en werk in je eigen tempo. Elk thema heeft een korte zelfscan om te zien waar je staat, trainingsmodules, en een toets waarmee je je certificaat haalt.</p>

      <div className="grid gap-6" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(290px,1fr))' }}>
        {THEMES.map((t, i) => {
          const pct = themeProgressPct(t.id);
          return (
            <Reveal key={t.id} delay={i * 70}>
              <Link to={`/thema/${t.id}`} className="card card-hover flex flex-col overflow-hidden h-full">
                <div style={{ background: '#FBFAF7', borderBottom: '1px solid #F0EBE3' }}>
                  <ThemeIllustration themeId={t.id} style={{ width: '100%', height: 138, display: 'block' }} />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center justify-between mb-4">
                    <ThemeGlyph theme={t} size={44} />
                    <p className="text-xs text-muted uppercase tracking-wide">{statusOf(pct)} · {t.mods} modules</p>
                  </div>
                  <h2 className="font-display font-semibold text-ink mb-1" style={{ fontSize: 22 }}>{t.name}</h2>
                  <p className="text-sub mb-6 flex-1">{t.long}</p>
                  <Track pct={pct} color={t.accent} />
                  <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold" style={{ color: t.accent }}>
                    {pct > 0 ? 'Verder gaan' : 'Start dit thema'} <ArrowRight className="w-4 h-4 cta-arrow" strokeWidth={2} />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
};
